// The v2 partial import re-classifies overlaps inside its row-locked transaction, against the
// paddocks that exist at THAT moment — so it can reject a batch the client had already clipped
// clean against an older snapshot. That rejection echoes the offending lote names
// (conflictingFeatureNames) onto the 4xx body, which apiClient hands over untouched as
// BusinessEntityError.response. Read defensively: this is untrusted wire data on an error path,
// and every other 4xx of this endpoint omits it entirely.
export const getServerConflictFeatureNames = (error: unknown): string[] => {
  const conflictingFeatureNames = (error as { response?: { conflictingFeatureNames?: unknown } })
    ?.response?.conflictingFeatureNames
  if (!Array.isArray(conflictingFeatureNames)) return []
  return conflictingFeatureNames.filter((name): name is string => typeof name === 'string')
}
